import type { AuthProvider } from '@refinedev/core';
import type { AppRole } from '@lebinatikra/shared-types';
import { supabaseClient } from './supabase-client';

export const authProvider: AuthProvider = {
  login: async ({ email, password }) => {
    const { error } = await supabaseClient.auth.signInWithPassword({ email, password });
    if (error) {
      return { success: false, error: { name: 'LoginError', message: error.message } };
    }
    return { success: true, redirectTo: '/communities' };
  },
  logout: async () => {
    await supabaseClient.auth.signOut();
    return { success: true, redirectTo: '/login' };
  },
  check: async () => {
    const { data } = await supabaseClient.auth.getSession();
    return data.session
      ? { authenticated: true }
      : {
          authenticated: false,
          redirectTo: '/login',
          error: { name: 'NoSession', message: 'no session' },
        };
  },
  getIdentity: async () => {
    const { data } = await supabaseClient.auth.getUser();
    const user = data.user;
    if (!user) return null;
    const meta = (user.app_metadata ?? {}) as Record<string, unknown>;
    return {
      id: user.id,
      email: user.email,
      name: (user.user_metadata?.name as string | undefined) ?? user.email,
      role: ((meta.role as string | undefined) ?? 'member') as AppRole,
      communityId: (meta.community_id as string | null | undefined) ?? null,
      organizationId: (meta.organization_id as string | null | undefined) ?? null,
    };
  },
  onError: async (error) => ({ error }),
};
